import { InjectionToken } from '@angular/core';
import { MobileLockModalData } from './mobile-lock.types';

export const MOBILE_LOCK_MODAL_DATA = new InjectionToken<MobileLockModalData>('MOBILE_LOCK_MODAL_DATA');



// WEBPACK FOOTER //
// ./ts/app/shared/mobile-lock/mobile-lock-modal.token.ts